module.exports = __webpack_public_path__ + "img/Segments.990ad08d.svg";